import pb from "@pb/index.json";

const PBOBJECT = pb.nested.yunpb.nested;

export const CloudGameCmd = PBOBJECT.CloudGameCmd.values;
export const UserStatusCmd = PBOBJECT.UserStatusCmdId.values;
export const StoreCmd = PBOBJECT.StoreCmd.values;
export const UserCmd = PBOBJECT.UserCmdId.values;
// export const UserCmdId = PBOBJECT.UserCmdId.values;

type COMMANDS_Type = {
  [key: string]: string;
};

const COMMANDS: COMMANDS_Type = {};

COMMANDS[CloudGameCmd.SVR_WEBRTC_CHANGE_INFO_NOTIFY] =
  "ChangeWebRtcInfoPushMsg";
COMMANDS[CloudGameCmd.CLT_QUE_CHANGE_NOTIFY] = "CltQueChangeNotify"; // 排队状态通知(业务服务到客户端)
COMMANDS[CloudGameCmd.CLT_CHARGE_NOTIFY] = "SvrChargeNotify"; // 通知玩家充值(业务服务到客户端)
COMMANDS[CloudGameCmd.CLT_ENTER_GAME_NOTIFY] = "EnterGamePushNotify"; // 通知玩家可以进入游戏(业务服务到客户端)
COMMANDS[CloudGameCmd.CLT_RETURN_BATTLEFIELD] = "SvrReturnBattlePush"; // 业务服务器主动通知客户端重返战场
COMMANDS[CloudGameCmd.CLT_ERROR_RESPONSE_ASYNC] = "CltErrorPushMsg";
COMMANDS[CloudGameCmd.CLT_GAME_EXIT_NOTIFY] = "CltGameExitNotify"; // 推送通知到客户端，游戏结束
COMMANDS[CloudGameCmd.SVR_KICK_PLAYER] = "BsPushMsg"; // 踢玩家(业务服务到云游戏)
COMMANDS[CloudGameCmd.CLT_KICK_BY_ADMIN] = "BsPushMsg"; // 被管理员踢出
COMMANDS[CloudGameCmd.CLT_PLAYER_TIME_OUT] = "CltTimeOutNotify"; // 玩家用时己结束(业务服务到客户端)
COMMANDS[CloudGameCmd.CLT_PLAYER_TIME_LEFT] = "SvrPushTimeLeftMsg"; // 业务服务端主动通知剩余时间
COMMANDS[UserStatusCmd.UC_UserStatusTakeLeave] = "BroadcastTakeLeave"; // 广播踢下线
COMMANDS[UserStatusCmd.UC_UserStatusRelogin] = "BroadcastRelogin"; // 广播踢下线
COMMANDS[StoreCmd.NOTICE_USER_PAY_SUCCESS] = "UserPaySuccess"; // 用户购买成功
COMMANDS[UserCmd.UC_UserInfoUpdate] = "UC_UserInfoUpdate"; // 用户信息发生变更
// COMMANDS[UserCmdId.UC_WebUserFreeTime] = "NoticeWebUserFreeTime"; // 新用户推送

export default COMMANDS;
